export const agentsConstants = {
    AGENTS_FETCH: 'AGENTS_FETCH',
    AGENTS_SUCCESS: 'AGENTS_SUCCESS',
    AGENTS_ERROR: 'AGENTS_ERROR',
    AGENTS_UPDATE: 'AGENTS_UPDATE',
};

export const AgentStatus = {
    Disabled: 0,
    Active: 1,
};
